import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'

import styles from './styles.scss'
import {
  compose,
  branch,
  renderComponent,
  pure
} from 'recompose'
import { IconButton } from 'react-toolbox/lib/button'

const withStyle = CSSModules(styles)

const RiskType = withStyle(props =>
  <span styleName='risk'>
    Risk
    <IconButton icon='warning' theme={styles} />
  </span>
)
const StandardType = withStyle(props => <span styleName='standard'>Standard</span>)

const RiskElement = compose(
  branch(
    ({ isRisk }) => isRisk,
    renderComponent(RiskType)
  ),
  pure
)(StandardType)

export default RiskElement
